import { useState } from 'react';
import { ShieldCheckIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { i18nService } from '../../services/i18n';

/** 展示当前云端 Runner 的真实策略；未协商权限档位前不提供无效的模式切换。 */
export default function CloudPermissionPolicy() {
  const [open, setOpen] = useState(false);
  return <div className="relative shrink-0" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }} onKeyDown={event => { if (event.key === 'Escape') setOpen(false); }}>
    <button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)}
      className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs text-claude-textSecondary hover:bg-claude-surfaceHover dark:text-claude-darkTextSecondary dark:hover:bg-claude-darkSurfaceHover"
      title={i18nService.t('coworkCloudPermissionTitle')}>
      <ShieldCheckIcon className="h-4 w-4 shrink-0" /><span className="whitespace-nowrap">{i18nService.t('coworkCloudPermissionTitle')}</span><ChevronDownIcon className="h-3 w-3" />
    </button>
    {open && <div className="absolute bottom-full left-0 z-50 mb-1.5 w-64 rounded-xl border border-claude-border bg-claude-surface p-3 text-xs leading-5 text-claude-textSecondary shadow-modal dark:border-claude-darkBorder dark:bg-claude-darkSurface dark:text-claude-darkTextSecondary" role="note">
      {i18nService.t('coworkCloudPermissionHint')}
    </div>}
  </div>;
}
